export function formatSales(amt) {
  if (!amt || isNaN(amt) || amt < 0) return '$0'
  if (amt < 1000) return `$${Math.round(amt)}`
  if (amt < 1000000) return `$${Math.round(amt / 1000)}K`
  return `$${(amt / 1000000).toFixed(1)}M`
}
